import styled from "styled-components"

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 3rem 0.5rem;

  ${({ theme }) => theme.breakpoints.desktop} {
    p {
      font-size: 18px;
    }
  }
`

export const TitleWrapper = styled.div`
  padding: 1.75rem 0;
  text-align: center;
`
